import { Component, Vue, Prop } from "vue-property-decorator";
import './page.less'

@Component({
  components: {
  }
})
export default class ProductionTable extends Vue {
  @Prop({ default: () => [] }) readonly columns: Array<any>
  @Prop({ default: () => [] }) readonly data: Array<any>
  @Prop({ default: false }) readonly loading: Boolean
  @Prop({ default: 300 }) readonly scrollY: Number
  @Prop({ default: '' }) readonly selectId: String
  @Prop({ default: 1 }) readonly current: Number
  @Prop({ default: 20 }) readonly pageSize: Number
  @Prop({ default: 0 }) readonly total: Number
  
  clickRow(record){
    this.$emit('clickRow',record)
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  handleTableChange(current: number, pageSize: number) {
    this.$emit('handleTableChange',current,pageSize)
  }

  render() {
    return (
      <div class="material-list">
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.scrollY }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 8px;left: 7px;"
          // style='position: relative; top: 10px; left: 3px;'
          show-total={total => `${this.showTotal(total)}`}
          current={this.current}
          pageSize={this.pageSize}
          total={this.total}
          on-change={this.handleTableChange}
          on-showSizeChange={this.handleTableChange}
          show-less-items
        />
      </div>
    )
  }
}

